import React from 'react';
import PropTypes from 'prop-types';
import LoaderButton from 'components/LoaderButton';
import ActionLock from '@material-ui/icons/Lock';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { signOut } from 'actions/sign-out';
import { styles } from './styles';

class SignOutButton extends React.Component {
  static propTypes = {
    next: PropTypes.func,
    endpoint: PropTypes.string,
    children: PropTypes.node,
    icon: PropTypes.func
  };

  static defaultProps = {
    next: () => {},
    children: <span>Sign Out</span>,
    icon: ActionLock
  };

  getEndpoint () {
    return (
      this.props.endpoint ||
      this.props.auth.getIn(['configure', 'currentEndpointKey']) ||
      this.props.auth.getIn(['configure', 'defaultEndpointKey'])
    );
  }

  handleClick () {
    this.props.dispatch(signOut(this.getEndpoint()))
      .then(this.props.next)
      .catch(() => {});
  }

  render () {
    let disabled = !this.props.auth.getIn(['user', 'isSignedIn']);
    const { classes } = this.props;
    return (
      <LoaderButton
        primary
        loading={this.props.auth.getIn(['signOut', this.getEndpoint(), 'loading'])}
        icon={this.props.icon}
        disabled={disabled}
        className={classes.signOutButton}
        onClick={this.handleClick.bind(this)}
        labelColor={'default'}
        {...this.props} />
    );
  }
}

const SignoutButton = connect(({auth}) => ({auth}))(SignOutButton);
export default withStyles(styles)(SignoutButton);



// WEBPACK FOOTER //
// ./src/components/OAuthSignOutButton/index.js